import { render } from "./DorAdvPopup.vue?vue&type=template&id=17b99810"
import script from "./DorAdvPopup.vue?vue&type=script&lang=js"
export * from "./DorAdvPopup.vue?vue&type=script&lang=js"

import "./DorAdvPopup.vue?vue&type=style&index=0&id=17b99810&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__